import { render, staticRenderFns } from "./SoldArticleComponent.vue?vue&type=template&id=b56f3efc&scoped=true"
import script from "./SoldArticleComponent.vue?vue&type=script&lang=js"
export * from "./SoldArticleComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b56f3efc",
  null
  
)

export default component.exports